import { useIntl } from 'react-intl';

import { AutoDismissFlag } from '@atlaskit/flag';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';
import { token } from '@atlaskit/tokens';

import { ComponentFlagId, HandleDismissedType } from 'src/redux/flags/types';

import { messages } from './load-context-flag.i18n';

type Props = {
  id: ComponentFlagId;
  description: string;
} & HandleDismissedType;

export const LoadContextErrorFlag = ({
  id,
  description,
  ...otherProps
}: Props): JSX.Element => {
  const intl = useIntl();

  return (
    <AutoDismissFlag
      {...otherProps}
      id={id}
      description={intl.formatMessage(messages.loadContextErrorDescription)}
      icon={
        <StatusErrorIcon
          spacing="spacious"
          label="Error"
          color={token('color.icon.danger')}
        />
      }
      title={intl.formatMessage(messages.loadContextErrorTitle)}
    />
  );
};
